module.exports = __webpack_public_path__ + "static/media/buzon-rojo-buzon.3205ec05.png";